import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { CalendarPlusIcon, HomeIcon, ImageIcon, PhoneIcon, SparklesIcon } from 'lucide-react';
const tabs = [{
  to: '/',
  label: 'Home',
  icon: HomeIcon,
  end: true
}, {
  to: '/services',
  label: 'Diensten',
  icon: SparklesIcon,
  end: false
}, {
  to: '/work',
  label: 'Ons werk',
  icon: ImageIcon,
  end: false
}, {
  to: '/contact',
  label: 'Contact',
  icon: PhoneIcon,
  end: false
}];
export function MobileTabBar() {
  const {
    pathname
  } = useLocation();
  if (pathname.startsWith('/book')) return null;
  return <nav aria-label="Snelnavigatie" className="safe-bottom z-40 flex shrink-0 items-center justify-around border-t border-edge bg-void px-2 pt-2 lg:hidden" data-id="element-734" data-mp="2tle08aqrdej8">
      {tabs.slice(0, 2).map(tab => <Tab key={tab.to} {...tab} data-id="element-735" data-mp="144wdok8ciu8g" />)}

      <NavLink to="/book" aria-label="Afspraak maken" className="flex flex-1 items-center justify-center pb-2" data-id="element-736" data-mp="1467i8m9m860m">
        {({
        isActive
      }) => <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-void ${isActive ? 'bg-white' : 'bg-ember'}`} data-id="element-737" data-mp="97h2wbv116wy">
            <CalendarPlusIcon className="h-6 w-6" aria-hidden="true" data-id="element-738" data-mp="4ewbfgzlf5wl" />
          </span>}
      </NavLink>

      {tabs.slice(2).map(tab => <Tab key={tab.to} {...tab} data-id="element-739" data-mp="3qp0afvfbvfb9" />)}
    </nav>;
}
function Tab({
  to,
  label,
  icon: Icon,
  end
}: {
  to: string;
  label: string;
  icon: typeof HomeIcon;
  end: boolean;
}) {
  return <NavLink to={to} end={end} aria-label={label} className="flex flex-1 items-center justify-center pb-2" data-id="element-740" data-mp="n8a0x6kjek4t">
      {({
      isActive
    }) => <span className={`flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-200 ease-smooth ${isActive ? 'bg-ember/15 text-ember' : 'text-dim'}`} data-id="element-741" data-mp="ia8f4dvq86pn">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-742" data-mp="2xz9vxl9sabem" />
        </span>}
    </NavLink>;
}